import styled from "styled-components";

const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: move;
  user-select: none;
  border: 1px solid var(--border-color);
  margin: 2px 0;
  border-radius: 10px;
  padding: 0 4px 8px 4px;
`;

export default Container;
